export default __webpack_public_path__ + "535cece5503e3ec8e4a6e268d6a3418d.png";